import React from 'react';
import PropTypes from 'prop-types';
import { CmsCta } from 'components/CmsPage/modules/CmsCta';
import { BackgroundImage } from 'components/Image/BackgroundImage';

export const UserQuote = ({ author, copy, cta, desktopImage, location, mediaQueryMd, mobileImage, theme, title }) => (
  <BackgroundImage url={mediaQueryMd ? desktopImage : mobileImage}>
    <div className="user-quote">
      <div className={`user-quote__content user-quote__content--${theme}`}>
        <blockquote className="user-quote__content__text">
          <h2>{title}</h2>
          <p className="text--lg">{copy}</p>
          <footer>
            <cite className="text--md text--bold">{author}</cite>
            <p className="text--xs">{location}</p>
          </footer>
        </blockquote>
        {cta && (
          <div className="user-quote__content__cta">
            <CmsCta {...cta} />
          </div>
        )}
      </div>
    </div>
  </BackgroundImage>
);

UserQuote.propTypes = {
  author: PropTypes.string,
  copy: PropTypes.string,
  cta: PropTypes.object,
  desktopImage: PropTypes.string.isRequired,
  location: PropTypes.string,
  mediaQueryMd: PropTypes.bool,
  mobileImage: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['dark', 'light']).isRequired,
  title: PropTypes.string.isRequired,
};
